export class FilterModel {
  PageSize = 'PageSize=' + 30;
  StartPageNo = 'StartPageNo=' + 1;
  RunCount = 'RunCount=' + true;
  SortExpression = 'SortExpression=';
  FilterEnabled = 'Filter.Enabled=' + true;
}

export class UserRoles {
  admin = false;
  client = false;
  patient = false;
}
